import styled from 'styled-components';
import { color, fontSize, fontWeight, radius, screen, spacing } from 'theme';

export const StyledRecharts = styled.div`
  overflow-y: hidden;
  overflow-x: hidden;

  @media (max-width: ${screen('mdMax')}) {
    overflow-x: auto;
  }

  .recharts-surface {
    max-height: 100%;
    border-radius: ${radius('sm')} !important;
    flex: 0 0 auto;
    align-self: flex-start;
    margin-top: 3px;
  }

  .recharts-cartesian-axis-line {
    stroke: ${color('midnight_200')};
  }

  .recharts-text {
    fill: ${color('text_default')};
    font-size: ${fontSize('sm')};
    text-transform: uppercase;
    font-weight: ${fontWeight('medium')};
  }
  &.dark {
    .recharts-text {
      fill: ${color('text_default_inverse')};
    }
    .recharts-legend-item-text {
      color: ${color('text_default_inverse')} !important;
    }
    .recharts-cartesian-axis-line {
      stroke: ${color('midnight_800')};
    }
  }
  &.skills {
    .recharts-text {
      fill: ${color('text_default')};
      font-size: ${fontSize('sm')};
      font-weight: ${fontWeight('medium')};
      text-transform: unset;
    }
  }
  &.methodology {
    .recharts-text {
      font-size: ${fontSize('xs2')};
      text-transform: unset;
    }
  }
  &.gender-by-role {
    .recharts-text {
      font-size: ${fontSize('xs')};
    }
  }

  .recharts-label {
    text-transform: inherit;
    fill: ${color('text_subtle')};
  }

  .recharts-label-list {
    text-transform: inherit;
    fill: ${color('text_subtle')};
    transform: translateZ(0);
  }

  .recharts-legend-wrapper {
    right: -${spacing('lg')} !important;
  }

  &.legend-top {
    .recharts-legend-wrapper {
      top: 0;
      bottom: unset !important;
    }
  }

  .recharts-legend-item {
    margin-bottom: ${spacing('xs')};
    margin-right: ${spacing('lg')} !important;
    display: flex !important;
    align-items: center;
  }

  &.gender .recharts-legend-item {
    display: inline-flex !important;
  }

  .recharts-legend-item-text {
    color: ${color('text_default')} !important;
    font-size: ${fontSize('sm')};
    text-align: left;
  }

  .recharts-default-tooltip {
    background-color: ${color('midnight_800')} !important;
    border: 0 !important;
    border-radius: ${radius('sm')};
    padding: ${spacing('sm')} !important;
    font-size: ${fontSize('sm')};
    color: ${color('text_white')};
    font-weight: ${fontWeight('medium')};
    position: relative;

    &::before {
      content: '';
      width: 0;
      height: 0;
      position: absolute;
    }
  }

  .recharts-tooltip-wrapper-bottom .recharts-default-tooltip.tooltip-y::before {
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-bottom: 6px solid ${color('midnight_800')};
    top: -5px;
    left: 50%;
    right: unset;
    transform: translateX(-50%);
  }

  .recharts-tooltip-wrapper-top .recharts-default-tooltip.tooltip-y::before {
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 6px solid ${color('midnight_800')};
    bottom: -5px;
    left: 50%;
    right: unset;
    transform: translateX(-50%);
  }

  .recharts-tooltip-wrapper-left .recharts-default-tooltip.tooltip-x::before {
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-left: 6px solid ${color('midnight_800')};
    right: -5px;
    left: unset;
    top: 50%;
    transform: translateY(-50%);
  }

  .recharts-tooltip-wrapper-right .recharts-default-tooltip.tooltip-x::before {
    border-top: 6px solid transparent;
    border-bottom: 6px solid transparent;
    border-right: 6px solid ${color('midnight_800')};
    left: -5px;
    top: 50%;
    transform: translateY(-50%);
  }

  .recharts-tooltip-item {
    padding: 0 !important;
    color: inherit !important;
  }

  .recharts-tooltip-item-name {
    font-weight: ${fontWeight('extraBold')};
  }

  .recharts-default-legend {
    display: flex;
    flex-wrap: wrap;
  }

  &.vertical-legend {
    .recharts-default-legend {
      flex-direction: column;
    }
  }

  &.xAxisLabel {
    .recharts-cartesian-axis-tick .recharts-text {
      text-transform: initial;
    }
  }

  &.treemap {
    text {
      fill: ${color('text_white')};
      font-size: ${fontSize('xs')};
      font-weight: ${fontWeight('medium')};
      stroke: none;
      filter: drop-shadow(1px 1px 0px rgba(0, 0, 0, 0.3));
    }
  }
`;
